import { useState, useEffect } from 'react';
import ServiceCard from '../components/ServiceCard';
import ProductCard from '../components/ProductCard';
import './Home.css';

// ── API base — change to your hosting URL in production ──
const API_BASE = process.env.REACT_APP_API_URL || '/backend/api';

const Home = () => {
  const slideshowImages = [
    'https://images.unsplash.com/photo-1539008835657-9e8e9680c956?w=1200',
    'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200',
    'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=1200',
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [newArrivals, setNewArrivals] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prev => (prev === slideshowImages.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [slideshowImages.length]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const [arrivalsRes, featuredRes] = await Promise.all([
          fetch(`${API_BASE}/products?section=new_arrivals`),
          fetch(`${API_BASE}/products?section=featured`),
        ]);
        const arrivals = await arrivalsRes.json();
        const featured = await featuredRes.json();
        setNewArrivals(arrivals.map(p => ({ ...p, link: `/shop?product=${p.id}` })));
        setFeaturedProducts(featured.map(p => ({ ...p, link: `/shop?product=${p.id}` })));
      } catch (err) {
        console.error('Could not load products:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const servicesData = [
    { number: '01', title: 'TAILORING', description: 'Ready-to-wear clothes, shirred dresses and tops for women, suits, custom-made clothes and uniforms of all types—expertly crafted in our Lilongwe studio.', image: '/images/products/batiki.jpeg' },
    { number: '02', title: 'PRINTING & EMBROIDERY', description: 'Transform your brand and style with expert screen printing, custom T-shirt printing, and precision embroidery. Serving businesses, schools, events, and individuals with bold, lasting quality on every garment.', image: '/images/products/hair-bonnet.jpeg' },
    { number: '03', title: 'Barrister and Graduation Gowns', description: 'Expertly crafted barrister and graduation gowns designed for excellence and prestige. In addition, we manufacture eco-friendly reusable pads, providing a sustainable, comfortable, and cost-effective solution for everyday use.', image: '/images/products/throw-pillows.jpeg' },
  ];

  return (
    <main>
      {/* Hero */}
      <section className="hero slideshow-hero">
        <div className="slideshow-background" style={{ backgroundImage: `url(${slideshowImages[currentImageIndex]})` }}></div>
        <div className="overlay"></div>
        <div className="container hero-container">
          <span className="hero-eyebrow">Pompano Garment Manufacturing</span>
          <h1>Crafted to Fit.<br />Made to Last.</h1>
          <p className="hero-text">
            Bespoke suits, custom made clothes, uniforms, screen printing, embroidery, graduation gowns, and more—all expertly made in our Area 18 studio.
          </p>
          <div className="hero-cta-group">
            <a href="/services" className="btn btn-primary">Explore Services</a>
            <a href="/shop" className="btn btn-outline">Shop Now</a>
          </div>
        </div>
        <div className="slideshow-dots">
          {slideshowImages.map((_, index) => (
            <span key={index} className={`dot ${index === currentImageIndex ? 'active' : ''}`} onClick={() => setCurrentImageIndex(index)}></span>
          ))}
        </div>
      </section>

      {/* Services */}
      <section className="section services">
        <div className="container">
          <h2 className="section-title">OUR SERVICES</h2>
          <p className="services-intro">Custom-made, just for you. From suits and dresses to uniforms, screen printing, embroidery, gowns, and reusable pads—we craft pieces that match your size, taste, and timeline.</p>
          <div className="services-grid">
            {servicesData.map(service => <ServiceCard key={service.number} {...service} />)}
          </div>
          <div className="services-cta">
            <a href="/services" className="btn btn-primary">View All Services</a>
          </div>
        </div>
      </section>

      {/* Offer Banner */}
      <section className="offer-banner">
        <div className="container">
          <h2>Everything Under One Roof</h2>
          <div className="offer-tags">
            {['Ready-to-Wear Clothes','Suits','Custom-Made Clothes','All Types of Uniforms','Shirred Dresses & Tops','Screen Printing','T-Shirt Printing','Embroidery','Barrister Gowns','Graduation Gowns','Reusable Pads'].map(tag => (
              <span key={tag} className="offer-tag">{tag}</span>
            ))}
          </div>
        </div>
      </section>

      {/* New Arrivals */}
      <section className="section new-arrivals">
        <div className="container">
          <h2 className="section-title">NEW ARRIVALS</h2>
          <p className="section-subtitle">New Arrivals 2025</p>
          {loading ? (
            <div className="products-loading">Loading…</div>
          ) : newArrivals.length > 0 ? (
            <div className="products-grid">
              {newArrivals.map(product => <ProductCard key={product.id} {...product} />)}
            </div>
          ) : (
            <p style={{textAlign:'center',color:'var(--text-light)'}}>No new arrivals yet.</p>
          )}
        </div>
      </section>

      {/* Featured */}
      <section className="section featured-products">
        <div className="container">
          <h2 className="section-title">FEATURED PRODUCTS</h2>
          {loading ? (
            <div className="products-loading">Loading…</div>
          ) : featuredProducts.length > 0 ? (
            <div className="products-grid">
              {featuredProducts.map(product => <ProductCard key={product.id} {...product} />)}
            </div>
          ) : (
            <p style={{textAlign:'center',color:'var(--text-light)'}}>No featured products yet.</p>
          )}
          <div className="services-cta" style={{marginTop:'40px'}}>
            <a href="/shop" className="btn btn-primary">View All Products</a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
